<template>
    <div>
        <table class="cic-table">
            <thead>
                <tr>
                    <th>{{ $t('Selected Files') }}</th>
                    <th style="width: 50px">{{ $t('Delete') }}</th>
                </tr>
            </thead>
        </table>
        <div class="fileuploadwrapper">
            <ElUpload
                ref="uploader"
                :accept="extensions.map((x) => `.${x}`).join(',')"
                :auto-upload="false"
                :data="{
                    index: index,
                    securityToken: $store.user.session.securityToken,
                    type: orgList ? 'organisation' : '',
                }"
                :limit="maxQueueLength"
                :on-change="handleChange"
                :on-error="handleError"
                :on-exceed="handleExceed"
                :on-remove="handleChange"
                :on-success="handleSuccess"
                action="media/upload"
                multiple
            >
                <ElButton ref="uploadButton" style="display: none" />
            </ElUpload>
        </div>
        <div class="cic-footer">
            <CicButton id="browse" @click="$refs.uploadButton.$el.click()">{{ $t('Browse...') }}</CicButton>
            <template v-if="showUpload">
                <CicButton id="clearAll" @click="clearFiles">{{ $t('Clear All') }}</CicButton>
                <CicButton id="upload" @click="handleSubmit">{{ $t('Upload') }}</CicButton>
            </template>
        </div>
    </div>
</template>

<script>
    import { ElButton, ElUpload } from 'element-plus';
    import CicButton from '@/components/CicButton';
    import loadMedia from './MediaUtils';

    export default {
        name: 'UploadMedia',
        components: {
            ElButton,
            CicButton,
            ElUpload,
        },
        props: {
            extensions: {
                type: Array,
                required: true,
            },
            maxFileSize: {
                type: Number,
                default: 10,
            },
            maxQueueLength: {
                type: Number,
                default: 10,
            },
            mediaListId: {
                type: Number,
                required: true,
            },
            orgList: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change'],
        data() {
            return {
                index: -1,
                results: [],
                showUpload: false,
            };
        },
        methods: {
            clearFiles() {
                this.$refs.uploader.clearFiles();
                this.showUpload = false;
            },
            handleChange(file, fileList) {
                if (file.size > this.maxFileSize) {
                    fileList.splice(fileList.indexOf(file), 1);
                    alert(this.$t('Maximum file size has been reached!'));
                }

                if (
                    !file.name.includes('.') ||
                    !this.extensions.includes(file.name.substring(file.name.lastIndexOf('.') + 1))
                ) {
                    fileList.splice(fileList.indexOf(file), 1);
                    alert(this.$t('Invalid file type!'));
                }

                this.showUpload = fileList.length > 0;
            },
            handleError(response, file, fileList) {
                this.results.push({ filename: file.name, status: 'error' });
                this.handleQueueComplete(fileList);
            },
            handleExceed() {
                alert(this.$t('Queue size limit has been reached!'));
            },
            handleQueueComplete(fileList) {
                if (fileList.length === this.results.length) {
                    const errors = this.results.filter((x) => x.status === 'error');
                    if (errors.length) {
                        this.$store.setMediaLoading(null);
                        alert(this.$t('Failed to upload file.'));
                    } else {
                        this.clearFiles();
                        this.$emit(
                            'change',
                            this.results.map((x) => x.prompt),
                        );
                    }
                }
            },
            handleSuccess(response, file, fileList) {
                this.results.push({
                    filename: file.name,
                    status: response.status,
                    errorMessage: response.errorMessage,
                    prompt: response.prompt,
                });
                this.handleQueueComplete(fileList);
            },
            handleSubmit() {
                this.results = [];
                loadMedia('medialibrary/mediauploadPrep', { mediaListId: this.mediaListId }, 'all', (response) => {
                    this.index = response.index;
                    this.$nextTick(() => this.$refs.uploader.submit());
                });
            },
        },
    };
</script>
